import axios from 'axios';

export default {
  get: (data) => axios.get('/api/v1/time'),
};
